import React from 'react'
import AvailabilityWidget from '../components/availability-widget';
import UniqueReasons from '../components/uniqueReasons';
import Helmet from 'react-helmet';
import Link from 'gatsby-link';
import ChristmasNotification from '../components/notifications/christmasNotification';
import Hero from '../components/hero';

const IndexPage = () => (
    <div className="frontpage">
        <Helmet
            title="Gifture Photobooth * Video * Gif * v.a. €195 all in"
            meta={[
                {
                    name: 'description',
                    content: `De compacte, stijlvolle photobooth met video en gif mogelijkheden! Een tikkeltje retro en o zo aanstekelijk! Delen via SMS en op social media pages. Verhuur in heel NL en dat voor all in prijzen vanaf €195!`
                },
                {
                    name: 'keywords',
                    content: [
                        'photobooth', 'videobooth', 'gifbooth', 'fotobooth',
                        'fotohokje', 'bruiloft', 'gif photobooth', 'huren',
                        'lenen', 'trouwerij', 'evenement', 'feest', 'bedrijfsfeest',
                        'borrel', 'beurzen', 'beurs', 'verhuur'
                    ].join(',')
                },
            ]}
        />
        <Hero centeredText={true} size="is-fullheight" hiddenMobile={true} image={require('../assets/images/heroImage.jpg')}>
            <div className="content">
                <h1>De leukste herinneringen maak je samen! <span>#memories #worth #sharing</span>!</h1>
                <AvailabilityWidget />
                <p>
                    Gebruik bovenstaande check om de beschikbaarheid te controleren of scroll verder en kom meer
                    te weten over de Gifture Photobooth.
                </p>
            </div>
        </Hero>

        {/*<div className="hero-ratings columns">*/}
            {/*<div className="column is-primary">*/}
                {/*<div className="content has-text-centered">*/}
                    {/*<h2>*/}
                        {/*De leukste foto's ontstaan later op de avond!*/}
                        {/*/!*<br />*!/*/}
                        {/*/!*Waarom dan stoppen als het net leuk begint te worden?*!/*/}
                    {/*</h2>*/}
                {/*</div>*/}
            {/*</div>*/}
            {/*<div className="column">*/}
                {/*<div className="has-text-centered">*/}
                    {/*<p>*/}
                        {/*Naarmate de avond vordert, worden de gasten wat losser en de foto's leuker en gekker! Stoppen wanneer het net leuk begint te worden zou dus zonde zijn!*/}
                        {/*Onze onbemande photobooths zijn daarom altijd <strong>inclusief 24 uur</strong> verhuur.*/}
                        {/*/!*<br /><br />*!/*/}
                        {/*/!*Vaak is begeleiding bij een photobooth niet eens noodzakelijk! Door de opvallende verlichting vallen onze photobooth snel op*!/*/}
                        {/*/!*en weten uw gasten snel de weg naar de photobooth te vinden! Maar mocht een enthousiaste medewerker wenselijk zijn*!/*/}
                        {/*/!*dan is dat uiteraard mogelijk!*!/*/}
                    {/*</p>*/}
                {/*</div>*/}
            {/*</div>*/}
        {/*</div>*/}

        <div className="section">
            <div className="container content">
                <div className="columns">
                    <div className="column">
                        <h4 className="has-text-centered">
                            PhotoBooth &#8226; VideoBooth &#8226; GifBooth
                        </h4>
                        <p>
                            Compact, stijlvol en een tikkeltje retro! Dat is de Gifture Photobooth. Maar laat je niet misleiden door het kleine formaat van deze photobooth. Dankzij zijn kleine formaat is de photobooth vrijwel overal te plaatsen. Plaats de booth prominent in het zicht of op een iets rustiger plekje met iets meer privacy en beschutting!
                        </p>
                        <p>
                            Deze kleine krachtpatser is een ware alles-in-èèn wonder! Collage’s, postcard, quotecard, boomerang gifjes (bekend van Instagram) en video boodschappen! Klaar? Verzend jouw creatie per SMS zodat je hem eenvoudig kunt delen op jouw eigen social media. Onze photobooth is volledig draadloos en wordt standaard geleverd met een accupack waarmee de booth minimaal 8 uur actief gebruikt kan worden!
                        </p>
                        <h4 className="has-text-centered">Staat onze photobooth straks bij jou op de vloer?</h4>
                        <p>
                            Voor €195,- kun je al een photobooth huren die je de hele dag op locatie hebt! Het organiseren van een feestje kan al stressvol genoeg zijn! Daarom is het mogelijk om de photobooth op locatie te laten bezorgen (binnen een straal van 50km vanaf ons kantoor in Leidschendam) en volledig te installeren voor jouw evenement, zodat je daar geen omkijken meer naar hebt!
                        </p>
                        <div className="button-list">
                            <Link to="/gifture-photobooths" className="button is-primary is-outlined">Ik heb binnenkort iets te vieren</Link>
                            <Link to="/gifture-photobooths" className="button is-primary is-outlined">Ik organiseer een evenement</Link>
                        </div>
                    </div>
                    <div className="column image">
                        <img src={require('../assets/images/small-picture-booth.jpg')} alt="Gifture Photobooth" title="De Gifture Photobooth - Een kleine krachtpatser!"/>
                    </div>
                </div>
            </div>
        </div>
        <UniqueReasons/>
    </div>
)

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js